
import { GetTrip, Trip } from '@clients/myTrips';
import { tripEventsMapping } from '@util/tripMapper';
import { Component, Prop } from 'vue-property-decorator';
import EcoScoreSection from '@components/shared/section/EcoScoreSection.vue'
import StatsSection, { StatDetail } from '@components/shared/section/TripDetailStats.vue'
import ChevronRightIcon from '@components/icons/icon-chevron-right.svg';
import Vue from 'vue';
import { namespace } from 'vuex-class';

const TriplogModule = namespace('Triplog');

@Component({
  name: 'TripDetailTabDetails',
  components: {
    StatsSection,
    EcoScoreSection,
    ChevronRightIcon
  }
})
export default class TripDetailTabDetails extends Vue {
  @TriplogModule.Action('fetchLatestTrip')
  private fetchLatestTrip;

  @TriplogModule.Getter('getFuelUnit')
  private fuelUnit: string;

  @Prop()
  private trip: GetTrip

  private disabled: boolean = false;

  get smartConnectStats(): StatDetail[] {
    return [
      {
        name: 'Ø-Umdrehungen / Minute',
        value: Math.round(this.smartConnectData.averageRpm),
        unit: 'rpm'
      },
      {
        name: 'Höchste Drehzahl',
        value: this.smartConnectData.maximumRpm,
        unit: 'rpm'
      },
      {
        name: 'Höchstgeschwindigkeit',
        value: this.smartConnectData.maximumSpeed,
        decimals: 2,
        unit: 'km/h'
      },
      {
        name: 'Parkzeit vor der Fahrt',
        value: Math.round(this.trip.parkingTimeBefore / 1000.0 / 60.0), // must be in minutes
        unit: 'duration'
      }
    ]
  }

  get fuelStats(): StatDetail[] {
    const { fuelInformation } = this.trip

    return [
      {
        name: 'Treibstoffverbrauch',
        value: fuelInformation.fuelConsumption,
        decimals: 2,
        unit: this.fuelUnit
      },
      {
        name: 'Ø-Treibstoffverbrauch',
        value: fuelInformation.averageFuelConsumption,
        decimals: 2,
        unit: `${this.fuelUnit}/100km`
      },
      {
        name: 'Treibstoffkosten',
        value: fuelInformation.fuelCost,
        decimals: 2,
        unit: '€'
      }
    ]
  }

  get eventStats(): StatDetail[] {
    const { events } = this.trip as GetTrip

    return tripEventsMapping.map(m => ({
      name: m.name,
      value: events.filter(e => e.type === m.type).length
    }));
  }

  get isSmartConnect() {
    return this.trip.extraData && this.smartConnectData;
  }

  get smartConnectData() {
    return this.trip.extraData.smartConnectData;
  }

  get hasScore() {
    return this.smartConnectData.score && this.smartConnectData.score.totalEcoScore
  }

  private async createFuelstop() {
    this.disabled = true;

    this.$router.push({
      name: 'fuelStopAdd',
      query: { vehicle: this.trip.vehicleId.toString(), prevTripId: this.trip.id.toString() }
    })
  }
}
